import { getProviderMeta } from 'types/provider';

type Props = {
  provider: string;
  isSearchPage?: boolean;
};

export default function CompanyLogo({ provider, isSearchPage = false }: Props) {
  const { logo, name } = getProviderMeta(provider);
  const size = isSearchPage ? 80 : 40;

  return (
    <div
      aria-label={name}
      title={name}
      style={{
        width: size,
        height: size,
        minWidth: size,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <img
        src={logo}
        alt={name}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
        }}
      />
    </div>
  );
}
